import Button from '@storeblocks/button';
import { InsuranceDetails } from 'Api/insurance';
import { CallUsMessageHtml } from 'Components/CallUsMessageHtml';
import { RouteName } from 'Features/router';
import { useFormikContext } from 'formik';
import { hasFormErrors } from 'Forms/ChangeForm/components/PriceFetcher/priceFetcher.hooks';
import { SubmissionAlert } from 'Forms/ChangeForm/products/car/changeCarForm.styles';
import { useFormStatus, useFormValues } from 'Forms/forms.hooks';
import React from 'react';
import { useNavigate } from 'react-router';
import { getAppText } from 'Utils/text';
import { getSubmitSuccessDescription } from '../cancelForm.helpers';
import { ButtonWrapper } from './cancelFormButtons.styled';

interface CancelFormButtonsProps {
  insurance: InsuranceDetails;
}

export const CancelFormButtons = ({
  insurance,
}: CancelFormButtonsProps): React.ReactElement => {
  const navigate = useNavigate();
  const { dirty, isSubmitting, submitCount, errors } = useFormikContext();
  const { submitSuccess, submitError } = useFormStatus();
  const values = useFormValues();
  const isFormWithErrors = hasFormErrors(errors);
  const disableSubmitButton = !dirty || (submitCount > 0 && isFormWithErrors);

  if (submitSuccess) {
    return (
      <>
        <SubmissionAlert
          variant="success"
          title={getAppText('cancel.successAlert.title')}
          description={getSubmitSuccessDescription(insurance, values)}
        />
        <ButtonWrapper>
          <Button
            iconLeft="arrow-left"
            variant="text"
            onClick={() => {
              navigate(
                `${RouteName.INSURANCE_DETAILS}/${insurance.policyNumber}`,
              );
              window.location.reload();
            }}
          >
            {getAppText('changeInsurance.button.back')}
          </Button>
        </ButtonWrapper>
      </>
    );
  }

  return (
    <>
      {submitError && (
        <SubmissionAlert
          variant="error"
          title={getAppText('cancel.electricScooter.alert.submitError.title')}
        >
          <CallUsMessageHtml />
        </SubmissionAlert>
      )}
      <ButtonWrapper>
        <Button
          loading={isSubmitting}
          disabled={disableSubmitButton}
          type="submit"
        >
          {getAppText('changeInsurance.button.confirm')}
        </Button>
        <Button
          iconLeft="arrow-left"
          variant="text"
          onClick={() => {
            navigate(
              `${RouteName.INSURANCE_DETAILS}/${insurance.policyNumber}`,
            );
            window.location.reload();
          }}
        >
          {getAppText('changeInsurance.button.back')}
        </Button>
      </ButtonWrapper>
    </>
  );
};
